import { useDispatch } from "react-redux";
import ExitButton from "./ExitButton";
import { useNavigate } from "react-router-dom";
import { editFestejo, emptyFestejos } from "../store/festejoSlice";
import { logout } from "../store/userSlice";
import { toast } from "react-toastify";
import { IMAGE_DELETED, SERVER_ERROR } from "../constants/messages";
import { deleteImageFestejo } from "../controllers/festejosCalls";
import "../css/components/ModalConfirmarEliminadoImagen.css";

function ModalConfirmarEliminadoImagen({
  id,
  index,
  image,
  setImage,
  setIndex,
  setImages,
  displayModalConfirmarEliminadoImagen,
  setDisplayModalConfirmarEliminadoImagen,
  setDisplayVisImagen,
  setIsLoading,
  setBlur,
  token,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onClickOpenVis = () => {
    setImage(image);
    setDisplayVisImagen("");
  };

  const onClickDelete = async () => {
    setIsLoading(true);

    if (!id || (index !== 0 && !index) || !token) {
      dispatch(emptyFestejos());
      dispatch(logout());
      toast.error(SERVER_ERROR);
      navigate("/login");
      return;
    }

    const response = await deleteImageFestejo(index, id, token);

    if (!response) {
      dispatch(emptyFestejos());
      dispatch(logout());
      toast.error(SERVER_ERROR);
      navigate("/login");
      return;
    }

    if (!response.success) {
      toast.error(response.message);
      if (response.unauthorized) {
        dispatch(emptyFestejos());
        dispatch(logout());
        navigate("/login");
      }
      setIsLoading(false);
      return;
    }

    dispatch(editFestejo(response.festejo));
    setDisplayModalConfirmarEliminadoImagen("d-none");
    setImages(response.festejo.images);
    setIndex(NaN);
    setBlur("");
    setIsLoading(false);
    toast.success(IMAGE_DELETED);
  };

  const onClickCancel = () => {
    setIndex(NaN);
    setDisplayModalConfirmarEliminadoImagen("d-none");
    setBlur("");
  };

  return (
    <div
      className={
        "modalConfirmarEliminadoImagen p-3 w-50 " +
        displayModalConfirmarEliminadoImagen
      }
    >
      <ExitButton
        setDisplayModal={setDisplayModalConfirmarEliminadoImagen}
        setIndex={setIndex}
        setImage={setImage}
        setBlur={setBlur}
      />
      <h5 className="d-flex justify-content-center mt-4 text-center">
        ¿Está seguro que desea eliminar la imagen?
      </h5>
      <div className="d-flex justify-content-center mt-4">
        <button
          className="btn btn-danger me-5"
          onClick={() => {
            onClickDelete();
          }}
        >
          Eliminar
        </button>
        <button
          type="button"
          className="btn btn-primary me-5"
          onClick={() => {
            onClickOpenVis();
          }}
        >
          Ver
        </button>
        <button
          className="btn btn-success"
          onClick={() => {
            onClickCancel();
          }}
        >
          Cancelar
        </button>
      </div>
    </div>
  );
}

export default ModalConfirmarEliminadoImagen;
